import { InspectConfig, InspectConfigAdd, InspectionListParams, InspectionOrder, InspectionOrderAdd, InspectionOrderItem, InspectionOrderStatus, InspectionProgress, InspectItemBody } from "@/types/inspection";
import request, { AxiosResponseBody } from ".";
import { CommonListParams } from "../types/common";


const URL = '/wms/v2/inspection';

const APIS = {

  orderList: URL + '/order/list',
  orderAdd: URL + '/order/add',
  orderFetch: (id: string) => `${URL}/order/${id}/fetch`,
  orderProgress: (id: string) => `${URL}/order/${id}/progress`,
  orderDel: (id: string) => `${URL}/order/${id}/cancel`,
  orderFinish: (id: string) => `${URL}/order/${id}/finish`,
  orderUpdate: (id: string) => `${URL}/order/${id}/update`,
  itemUpdate: (id: string) => `${URL}/item/${id}/update`,
  itemInspect: (id: string) => `${URL}/item/${id}/inspect`,
  itemList: (status?: InspectionOrderStatus) => `${URL}/item${status === undefined ? '' : '/' + status}/list`,
  productConfigAdd: (id: string) => `${URL}/product/${id}/config/add`,
  productConfigGet: (id: string) => `${URL}/product/${id}/config/get`,
  productConfigUpdate: (id: string, configId: string) => `${URL}/product/${id}/config/${configId}/update`,
};

export const orderList = (params: CommonListParams<InspectionListParams>) => {
  return new Promise<AxiosResponseBody<Array<InspectionOrder>>>((resolve, reject) => {
    request<Array<InspectionOrder>, InspectionListParams>(APIS.orderList, { params })
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  })
};

export const orderAdd = (body: InspectionOrderAdd) => {
  return new Promise<InspectionOrder>((resolve, reject) => {
    request<InspectionOrder, InspectionOrderAdd>(APIS.orderAdd, { params: { body } })
      .then(({ body }) => resolve(body))
      .catch((err) => reject(err));
  })
};

export const orderFetch = (id: string) => {
  return new Promise<InspectionOrder>((resolve, reject) => {
    request<InspectionOrder, undefined>(APIS.orderFetch(id))
      .then(({ body }) => resolve(body))
      .catch((err) => reject(err));
  })
};

export const orderProgress = (id: string) => {
  return new Promise<InspectionProgress>((resolve, reject) => {
    request<InspectionProgress, undefined>(APIS.orderProgress(id))
      .then(({ body }) => resolve(body))
      .catch((err) => reject(err));
  })
};

export const orderDel = (id: string) => {
  return new Promise<void>((resolve, reject) => {
    request<void, undefined>(APIS.orderDel(id))
      .then(() => resolve())
      .catch((err) => reject(err));
  })
};

export const orderFinish = (id: string) => {
  return new Promise<void>((resolve, reject) => {
    request<void, undefined>(APIS.orderFinish(id))
      .then(() => resolve())
      .catch((err) => reject(err));
  })
};

export const orderUpdate = (id: string, body: Partial<InspectionOrderAdd>) => {
  return new Promise<InspectionOrder>((resolve, reject) => {
    request<InspectionOrder, Partial<InspectionOrderAdd>>(APIS.orderUpdate(id), { params: { body } })
      .then(({ body }) => resolve(body))
      .catch((err) => reject(err));
  })
};

export const itemUpdate = (id: string, body: Partial<InspectItemBody>) => {
  return new Promise<void>((resolve, reject) => {
    request<void, Partial<InspectItemBody>>(APIS.itemUpdate(id), { params: { body } })
      .then(({ body }) => resolve(body))
      .catch((err) => reject(err));
  })
};

export const itemInspect = (id: string, body: Partial<InspectItemBody>) => {
  return new Promise<void>((resolve, reject) => {
    request<void, Partial<InspectItemBody>>(APIS.itemInspect(id), { params: { body } })
      .then(({ body }) => resolve(body))
      .catch((err) => reject(err));
  })
};

export const itemList = (status: InspectionOrderStatus | undefined, params: CommonListParams) => {
  return new Promise<AxiosResponseBody<InspectionOrderItem[]>>((resolve, reject) => {
    request<InspectionOrderItem[], string>(APIS.itemList(status), { params })
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  })
};

export const productConfigAdd = (id: string, body: InspectConfigAdd) => {
  return new Promise<InspectConfig>((resolve, reject) => {
    request<InspectConfig, InspectConfigAdd>(APIS.productConfigAdd(id), { params: { body } })
      .then(({ body }) => resolve(body))
      .catch((err) => reject(err));
  })
};

export const productConfigGet = (id: string) => {
  return new Promise<InspectConfig>((resolve, reject) => {
    request<InspectConfig, undefined>(APIS.productConfigGet(id))
      .then(({ body }) => resolve(body))
      .catch((err) => reject(err));
  })
};

export const productConfigUpdate = (id: string, configId: string, body: InspectConfigAdd) => {
  return new Promise<InspectConfig>((resolve, reject) => {
    request<InspectConfig, InspectConfigAdd>(APIS.productConfigUpdate(id, configId), { params: { body } })
      .then(({ body }) => resolve(body))
      .catch((err) => reject(err));
  })
};